import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CostPlanService } from '../services/cost-plan.service';

@Component({
    selector: 'cost-plan-card',
    imports: [CommonModule],
    templateUrl: './cost-plan-card.component.html',
    styleUrl: './cost-plan-card.component.less',
})
export class CostPlanCardComponent {
    constructor(
        private router: Router,
        private costPlanService: CostPlanService
    ) {
        this.smallTeamConfig = this.costPlanService.getDefaultPlans('small');
        this.largeTeamConfig = this.costPlanService.getDefaultPlans('large');
        this.customizeTeamConfig = this.costPlanService.getDefaultPlans('customize');
    }

    smallTeamConfig = {};

    largeTeamConfig = {};

    customizeTeamConfig = {};

    navigateToPlan(planType: string): void {
        this.router.navigateByUrl(`/main/cost-plan/${planType}`);
    }
}
